import styles from './ShopHero.module.css';

interface ShopHeroProps {
  dropCode: string;
  totalCount: number;
  liveCount: number;
  soldCount: number;
}

export default function ShopHero({ dropCode, totalCount, liveCount, soldCount }: ShopHeroProps) {
  return (
    <header className={styles.root}>
      <div className={styles.title}>
        <span className="nano">/ SHOP / OBJECTS IN FREQUENCY</span>
        <h1>
          MOCT MERCH
          <br />
          <span className={styles.dim}>/ LIMITED CLUB UNIFORM</span>
        </h1>
      </div>
      <div className={styles.meta}>
        <span>CATALOG · {dropCode}</span>
        <span>
          {totalCount} OBJECTS · {liveCount} OPEN · {soldCount} SOLD
        </span>
        <span>SHIP YEREVAN ◦ INTL</span>
      </div>
    </header>
  );
}
